import { useState, type FormEvent } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export function LoginPage() {
  const { status, login } = useAuth();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [invite, setInvite] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (status === "authed") return <Navigate to="/app" replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login({
        password: password.trim() || undefined,
        invite: invite.trim() || undefined,
      });
      nav("/app");
    } catch (ex) {
      setErr(ex instanceof Error ? ex.message : "login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="shell">
      <div className="noise" aria-hidden />
      <div className="aurora" aria-hidden />
      <div className="scanline" aria-hidden />

      <div className="login-wrap">
        <form className="login-panel" onSubmit={onSubmit}>
          <h1>Access</h1>
          <p>Пароль или invite-код. Сессия в httpOnly cookie.</p>
          {err ? <p className="err">{err}</p> : null}

          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>

          <p className="or">or invite</p>

          <div className="field">
            <label htmlFor="invite">Invite code</label>
            <input
              id="invite"
              type="text"
              autoComplete="off"
              value={invite}
              onChange={(e) => setInvite(e.target.value)}
              placeholder="one-time code"
            />
          </div>

          <div className="login-actions">
            <button className="btn blood" type="submit" disabled={busy}>
              {busy ? "…" : "Enter"}
            </button>
            <Link className="btn ghost" to="/">
              Back
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
